module.exports = __webpack_public_path__ + "static/media/Enmovil_User_Guide_OptiRun_v6_0.aa9b596d.pdf";